var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLivePriceInfo = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0026 0.332031C3.3226 0.332031 0.335938 3.3187 0.335938 6.9987C0.335938 10.6787 3.3226 13.6654 7.0026 13.6654C10.6826 13.6654 13.6693 10.6787 13.6693 6.9987C13.6693 3.3187 10.6826 0.332031 7.0026 0.332031ZM7.66927 10.332H6.33594V6.33203H7.66927V10.332ZM7.66927 4.9987H6.33594V3.66536H7.66927V4.9987Z",
    fill: "#7E8899"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLivePriceInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/livePriceInfo.0a97136a6cb58ca42bbc8b123504981c.svg";